const VARIANT_PIN_PREFIX = 'nutrisense:experiment_variant:'

export const getPinnedExperimentVariant = (flag: string): string | null => {
  try {
    return sessionStorage.getItem(`${VARIANT_PIN_PREFIX}${flag}`)
  } catch {
    return null
  }
}

export const pinExperimentVariant = (flag: string, variantName: string): void => {
  try {
    if (getPinnedExperimentVariant(flag)) {
      return
    }

    sessionStorage.setItem(`${VARIANT_PIN_PREFIX}${flag}`, variantName)
  } catch {
    // sessionStorage is not available. Keep going without it.
  }
}
